<template lang="pug">
  #listagem-conversas
    p.bolder Listagem de Conversas
    el-card(shadow="hover")
      p.bolder Filtros
      el-row.margin-left
        el-col(:xs="12" :lg="7" :xl ="5" :sm="10")
          InputEntreDatas(
            placeholder="Período"
            :calendario="calendario"
            v-model="calendario"
          )
        el-col(:xs="24" :lg="9" :xl ="6" :sm="13")
          p Assunto
          el-select(
            style="width: 24rem"
            v-model="filtro.assunto"
            filterable
            clearable
            multiple
            collapse-tags
          )
            el-option(
              v-for="item in assuntos"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
        el-col(:xs="24" :lg="8" :xl ="4" :sm="10")
          p Responsável
          el-select(
            v-model="filtro.idsResponsaveis"
            multiple
            collapse-tags
            filterable
            clearable
          )
            el-option(
              v-for="item in responsaveis"
              :key="item.pessoa.pessoaFisica.id"
              :label="item.pessoa.pessoaFisica.nome"
              :value="item.pessoa.pessoaFisica.id"
            )
        el-col(:xs="24" :lg="7" :xl ="5" :sm="12")
          p Interessado
          el-input(
            v-model="filtro.nomeInteressados"
            style="width: 18.5rem"
          )
        el-col(:xs="24" :lg="6" :xl ="4" :sm="13")
          p Status
          el-select(
            v-model="filtro.status"
            multiple
            collapse-tags
            filterable
            clearable
          )
            el-option(
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
      el-row.margin.float
        el-button(
          type="text"
          size="medium"
          round
          @click="handleLimpar"
        ) Limpar
        el-button(
          type="primary"
          size="medium"
          round
          @click="handleFiltrar"
        ) Filtrar
    .cards
      CardDashboard(
        :content="totalConversas" title="Total de conversas"
        icon="far fa-comments" color="#00537e"
      )
      CardDashboard(
        title="Encerradas" :content="finalizadas"
        icon="far fa-calendar-check" color="blue"
      )
      CardDashboard(
        title="Respondidas" :content="respondidas"
        icon="far fa-comment-check" color="green"
      )
      CardDashboard(
        title="Aguardando resposta" :content="aguardandoResposta"
        icon="far fa-alarm-exclamation" color="yellow"
      )
    el-table(
      :data="dadosTabela"
      empty-text = "Não há dados registrados"
    ).margin-top
      el-table-column(
        sortable
        v-for="item in nomeColunas"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
      )
    app-paginacao(
      :total="totalConversas"
      :pagina="1"
      @changePage="alterarPagina"
    )
    el-row.botao-exportar.float
      BotaoExportarSelecionado(
        @exportar-csv-tabela="exportarCsvTabela"
        :dadosFiltro="filtro"
        :selecionadoCondicao="false"
        :disabled="botaoExportarDesligado"
        tab="listagemConversas"
      )
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { CardDashboard } from 'sicarf-components'

import AppNotificacao from '@/components/mixins/AppNotificacao'
import InputEntreDatas from './components/InputEntreDatas'
import { status, assuntos, nomesColunasListagem } from './components/conversas/nomesEstaticos'
import BotaoExportarSelecionado from './components/BotaoExportarSelecionado'
import AppPaginacao from '@/components/AppPaginacao'

export default {
  name: 'ListagemConversas',
  mixins: [
    AppNotificacao
  ],
  components: {
    InputEntreDatas,
    CardDashboard,
    BotaoExportarSelecionado,
    AppPaginacao
  },

  data () {
    return {
      calendario: [],
      responsaveis: [],
      status: [],
      aguardandoResposta: 0,
      respondidas: 0,
      finalizadas: 0,
      totalConversas: 0,
      totalPages: 0,
      currentPage: 0,
      dadosFiltro: [],
      dadosTabela: [],
      nomeColunas: [],
      botaoExportarDesligado: false,
      tableLoading: true,
      filtro: {
        pagina: 0,
        dataInicio: null,
        dataFim: null,
        assunto: [],
        idsResponsaveis: [],
        nomeInteressados: null,
        status: []
      }
    }
  },

  methods: {
    ...mapActions({
      findResponsaveis: 'filtros/findResponsaveis',
      filtrarPorStatusTotal: 'filtros/filtrarPorStatusTotal',
      listarConversas: 'filtros/listarConversas'
    }),
    alterarPagina (pagina) {
      this.filtro.pagina = pagina - 1
      this.listarTodasConversas()
    },
    handleLimpar () {
      this.calendario = []
      this.filtro = {
        dataInicio: null,
        dataFim: null,
        assunto: [],
        idsResponsaveis: [],
        nomeInteressados: null,
        status: []
      }
      this.getTodasConversas()
      this.listarTodasConversas().then(() => this.seNaoHaDados())
    },

    async exportarCsvTabela () {
      await this.BotaoExportarSelecionado.exportarSelecionado()
    },

    seNaoHaDados () {
      if (this.dadosFiltro.every(elem => elem.quantidade === 0)
      ) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'Nenhuma conversa encontrada neste periodo.')
        this.botaoExportarDesligado = true
        this.aguardandoResposta = 0
        this.respondidas = 0
        this.finalizadas = 0
        this.totalConversas = 0
      } else {
        this.getTodasConversasFiltro()
        this.botaoExportarDesligado = false
      }
    },

    // Função para listar as conversas na tabela
    listarConversasTabela () {
      const dados = this.dadosFiltro.map(dado => ({
        assunto: dado.assuntoDescricao,

        responsavel: dado.mensagemList[1] &&
        dado.mensagemList[1].destinatario !== null
          ? dado.mensagemList[1].remetente.pessoaFisica.nome : '-',

        interessado: dado.mensagemList[0].remetente.pessoaFisica.nome,

        dataInicioConversa: dado.mensagemList[0].dataEnviadaFormatadaSemHoras,

        dataResposta: dado.mensagemList[1] &&
        dado.mensagemList[1].dataEnviadaFormatadaSemHoras
          ? dado.mensagemList[1].dataEnviadaFormatadaSemHoras : '-',

        status: dado.statusDescricao
      }))
      this.dadosTabela = dados
    },
    // Alterei algumas condiçoes para listagem de conversa
    async handleFiltrar () {
      if (
        this.calendario <= 0 &&
        this.filtro.assunto <= 0 &&
        this.filtro.idsResponsaveis <= 0 &&
        this.filtro.nomeInteressados <= 0 &&
        this.filtro.status <= 0
      ) {
        this.dadosFiltro = await this.listarConversas()
        this.seNaoHaDados()
        this.listarConversasTabela()
      } else if (
        this.calendario <= 0 &&
        !this.filtro.assunto >= 0 &&
        !this.filtro.idsResponsaveis >= 0 &&
        !this.filtro.nomeInteressados >= 0 &&
        !this.filtro.status >= 0
      ) {
        this.dadosFiltro = await this.listarConversas(this.filtro)
        this.listarConversasTabela()
        this.seNaoHaDados()
      } else {
        this.filtro.dataInicio = moment(this.calendario[0]).format('yyyy-MM-DD')
        this.filtro.dataFim = moment(this.calendario[1]).format('yyyy-MM-DD')
        this.dadosFiltro = await this.listarConversas(this.filtro)
        this.seNaoHaDados()
        this.listarConversasTabela()
      }
    },

    async getResponsaveis () {
      this.responsaveis = await this.findResponsaveis()
    },

    // Função adicionada para deixar de acordo com a resposta do filtro
    async getTodasConversasFiltro () {
      const [
        aguardandoResposta,
        respondidas,
        finalizadas,
        totalConversas
      ] = await this.filtrarPorStatusTotal(this.filtro)

      this.aguardandoResposta = aguardandoResposta.quantidade
      this.respondidas = respondidas.quantidade
      this.finalizadas = finalizadas.quantidade
      this.totalConversas = totalConversas.quantidade
    },

    // Fiz essa desestruturação para pegar os valores do filtro e mostrar nos cards
    async getTodasConversas () {
      const [
        aguardandoResposta,
        respondidas,
        finalizadas,
        totalConversas
      ] = await this.filtrarPorStatusTotal()

      this.aguardandoResposta = aguardandoResposta.quantidade
      this.respondidas = respondidas.quantidade
      this.finalizadas = finalizadas.quantidade
      this.totalConversas = totalConversas.quantidade
    },

    async listarTodasConversas () {
      this.dadosFiltro = await this.listarConversas(this.filtro)
      this.listarConversasTabela()
    }
  },

  created () {
    this.status = status
    this.assuntos = assuntos
    this.nomeColunas = nomesColunasListagem
  },

  mounted () {
    this.getResponsaveis()
    this.getTodasConversas()
    this.listarTodasConversas()
  }
}
</script>

<style lang="scss" scoped>

  .bolder {
    font-size: 20px;
    font-weight: bolder;
    color: #606266;
  }

  .margin-left {
    margin-left: 0.3rem;
  }

  .margin {
    margin: 1.5rem 2rem 1.5rem;
  }

  .margin-top {
    margin-top: 1rem;
  }

  .float {
    float: right;
  }

  /deep/ .cell {
    color: #424242;
  }

  .cards {
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
  }

  .botao-exportar {
    margin: 1rem 2rem 1.5rem;
  }

  .card-dashboard {
    margin-right: 1.5rem;
    max-width: 25rem;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios_ouvidoria/ListagemConversas.vue